import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import emptyId from '~/statics/empty-id'
import Endpoints from '@nikan/endpoints'
import { globalLogger } from '~/plugins/logger'

const KEYS = {
  Prepare: 'prepare',
  Add: 'add',
  SetAsDeleted: 'setAsDeleted',
  SetAsUpdated: 'setAsUpdated',
  Clear: 'clear',
  Commit: 'commit'
}

export const mutations = {
  [KEYS.Prepare](state, list) {
    if (list == null || !Array.isArray(list)) {
      return
    }

    state.states = [...list]
  },

  [KEYS.Add](state, list) {
    if (list == null || !Array.isArray(list)) {
      return
    }
    var createds = list.filter(item => item.rowState === 'new' && item.id === emptyId)
    let mode = window.innerWidth < 768 ? 1 : 2
    for (var i = 0; i < createds.length; i++) {
      createds[i].mode = mode
    }
    state.states = state.states.concat(createds)
  },

  [KEYS.SetAsDeleted](state, list) {
    if (list == null || !Array.isArray(list)) {
      return
    }

    for (let value of state.states) {
      if (list.findIndex(d => d.rowState === 'deleted' && d.id === value.id) > -1) {
        value.rowState = 'deleted'
      }
    }
  },

  [KEYS.SetAsUpdated](state, list) {
    if (list == null || !Array.isArray(list)) {
      return
    }

    var updateds = list.filter(item => item.rowState === 'changed' && item.id !== emptyId)
    _.remove(state.states, item => updateds.findIndex(updated => updated.id === item.id) > -1)

    state.states = state.states.concat(updateds)
  },

  [KEYS.Commit](state) {
    let last = state.states.length - 1
    for (var i = last; i >= 0; i--) {
      let item = state.states[i]
      if (item.rowState === 'deleted') {
        state.states.splice(i, 1)
      } else if (item.rowState === 'changed' || item.rowState === 'new') {
        item.rowState = 'unchanged'
      }
    }
  },

  [KEYS.Clear](state) {
    state.states = []
  }
}

export const actions = {
  refresh({ state, commit }, options) {
    return new Promise((resolve, reject) => {
      options = _.merge({ force: false }, options)

      if (options.force !== true) {
        if (state.items.length) {
          resolve(state.items)
          return
        }
      }

      let params = {}

      let mode = ''
      if (window.innerWidth < 768)
        mode = 1 // 1 is mobile
      else
        mode = 2 // 2 is desktop

      params = { mode: mode }

      post(Endpoints.getUrl('general.appStates.list'), params, null, { preventConcurrent: false })
        .then(result => {
          if (result.success) {
            let items = result.data.items.map(item => {
              return _.merge(item, {
                value: typeof item.value == 'object' ? item.value : JSON.parse(item.value)
              })
            })
            commit(KEYS.Prepare, items)
            resolve(items)
          }
        })
        .catch(error => reject(error))
    })
  },

  sync({ dispatch, commit, state, getters }) {
    if (getters.isDirty === true) {
      return new Promise((resolve, reject) => {
        try {
          const fetch = async () => {
            commit(KEYS.Commit)
            await dispatch('refresh', { force: true })
            globalLogger.log('app state sync completed')
          }

          var items = state.states.filter(x => x.rowState !== 'unchanged')
          if (items.length > 0) {
            return post(Endpoints.getUrl('general.appStates.modify'), { items }, null, { preventConcurrent: false })
              .then(() => fetch())
              .then(resolve)
              .catch(reject)
          } else {
            fetch()
              .then(resolve)
              .catch(reject)
          }
        } catch (e) {
          globalLogger.error('unable to complete app state sync with server')
        }
      })
    } else {
      return Promise.resolve()
    }
  },

  modify({ commit }, list) {
    commit(KEYS.Add, list)
    commit(KEYS.SetAsDeleted, list)
    commit(KEYS.SetAsUpdated, list)
  },

  clear({ commit }) {
    commit(KEYS.Clear)
  }
}

export default {
  namespaced: true,
  state: {
    states: []
  },
  mutations,
  actions,
  getters: {
    all: state => {
      return state.states
    },
    getByKey: state => key => {
      return state.states.filter(item => item?.key === key)
    },
    getActiveByKey: (state, getters) => key => {
      return state.states.filter(item => item?.key === key && item.isActive)[0]
    },
    isDirty: state => {
      return state.states.filter(item => item.rowState !== 'unchanged').length > 0
    }
  }
}
